var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckboxOk = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.000321 0H15v14.999786H.000321z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.173961 14C.558871 13.99559.049604 13.52264 0 12.91078V1.173006C.013228.530278.531314.012126 1.173961 0h11.735203c.623908.020947 1.11113.543507 1.090185 1.167493V12.91078c-.011023.597528-.492733 1.079298-1.090185 1.08922H1.17396z",
    fill: "#94CC88"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.333179.000857H1.667464C.747107.003.003536.747643.000321 1.668v11.664643c.002143.920357.746786 1.665 1.667143 1.667143H13.33318c.919285-.002143 1.665-.746786 1.667142-1.667143V1.668C14.99818.747643 14.252464.001929 13.33318-.000214v.001071zm0 1.082021c.313928-.006307.575357.242265.582857.557265V13.332643c.0075.315-.243215.575357-.557143.582857H1.667464c-.315.0075-.576428-.241071-.582857-.556071-.001071-.009643-.001071-.018215 0-.026786V1.668c-.0075-.315.241072-.576429.556072-.582857.009642-.001072.018214-.001072.026785 0H13.33318v-.002265z",
    fill: "#60AD54",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF7FC",
    d: "M5.9281 11L2 7.634005l1.1-.941866 2.8281 2.423035L11.9 4l1.1.941866z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxOk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Checkbox_ok.52c5a6cc.svg";
export { ForwardRef as ReactComponent };